import { useEffect } from "react";

/**
 * SEOHead — updates document title, meta description, and canonical link per page.
 * Simple SPA SEO without external dependencies.
 */
const SEOHead = ({ title, description, canonical }) => {
  useEffect(() => {
    if (title) document.title = title;

    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement("meta");
      metaDesc.setAttribute("name", "description");
      document.head.appendChild(metaDesc);
    }
    if (description) metaDesc.setAttribute("content", description);

    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonical);
    }
  }, [title, description, canonical]);

  return null;
};

export default SEOHead;
